import Section from "../../layout/Section/Section";
import { industryGroups } from "../../../data/industries";
import styles from "./IndustriesTeaser.module.css";

const groupIcons = {
  "food-hospitality": <><path d="M5 3v7m3-7v7M3 6h7m-7 4h7M6.5 10v11M17 3v18m0-18c5 3 5 9 0 9" /></>,
  retail: <><path d="M4 9h16v12H4zM3 9l2-6h14l2 6M9 21v-7h6v7" /><path d="M3 9c0 3 4 3 4 0 0 3 5 3 5 0 0 3 5 3 5 0 0 3 4 3 4 0" /></>,
  health: <><rect x="4" y="4" width="16" height="16" rx="4" /><path d="M12 8v8m-4-4h8" /></>,
  "education-services": <><path d="m2 8 10-5 10 5-10 5L2 8Zm4 3v6c4 3 8 3 12 0v-6m4-3v9" /></>,
  "property-auto": <><path d="m3 11 9-8 9 8M5 9v12h14V9M9 21v-7h6v7" /></>,
};

function IndustryIcon({ id }) {
  return (
    <svg viewBox="0 0 24 24" width="23" height="23" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {groupIcons[id]}
    </svg>
  );
}

export default function IndustriesTeaser() {
  const count = industryGroups.reduce((total, group) => total + group.industries.length, 0);

  return (
    <Section id="industries" bg="white">
      <div className={styles.layout}>
        <div className={styles.copy}>
          <span className="eyebrow">Made for your kind of business</span>
          <h2 className={styles.title}>Local roots.<br />Bigger possibilities.</h2>
          <p className={styles.text}>
            From the neighbourhood café to the growing clinic. We help businesses
            of every kind build a presence that feels like them.
          </p>
          <a className={styles.link} href="/our-clients">
            Explore all {count} business types
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12h14m-5-5 5 5-5 5" /></svg>
          </a>
          <div className={styles.note}>
            <span className={styles.noteMark} aria-hidden="true">↗</span>
            <span>Your business is unique.<br /><strong>Your online presence should be, too.</strong></span>
          </div>
        </div>

        <ul className={styles.directory} aria-label="Industries we serve">
          {industryGroups.map((group) => (
            <li key={group.id}>
              <a href="/our-clients" className={styles.industry}>
                <span className={styles.icon}><IndustryIcon id={group.id} /></span>
                <span className={styles.details}>
                  <span className={styles.name}>{group.title}</span>
                  <span className={styles.examples}>{group.industries.slice(0, 3).join(" · ")}</span>
                </span>
                <svg className={styles.arrow} viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M6 18 18 6M6 6h12v12" /></svg>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </Section>
  );
}
